import { makeStyles, createStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() =>
  createStyles({
        DetailsToolTip: {
            height: "fit-content",
            width: "100%",
            cursor: "default"
        },
        DetailsToolTipExpand: {
            height: "fit-content",
            width: "fit-content",
            marginTop: "-6px"
        },
        DetailsToolTipBody: {
            width: "100%",
            display: "flex",
            justifyContent: "center",
        },
        DetailsToolTipBodyRight: {
            position: "absolute",
            left: "220px",
            transform: "translateX(-70%)",
        },
        DetailsToolTipBodyCenter: {
            position: "absolute",
            left: "200px",
            top: "30px",
            transform: "translateX(-130%)",
        },
        DetailsToolTipBodyLeft: {
            position: "absolute",
            left: "-30%",
            transform: "translateX(-70%)",
        },
        DetailsToolTipBodyContent: {
            position: "relative",
            width: "250px",
            maxWidth: "auto",
            height: "auto",
            backgroundColor: "#e2e6f3",
            padding: "8px 11px",
            boxShadow: "0px 0px 3px rgba(32, 47, 47, 0.36)",
            borderRadius: "4px",
            fontWeight: 400,
        },
        DetailsToolTipIconPositionRight: {
            cursor: "pointer",
            position: "absolute",
            float: "right",
            width: "20px",
            height: "20px",
            borderRadius: "24px",
            fontSize: "1.2rem",
            top: "9px",
            right: "10px",
        },
        DetailsToolTipIconPositionLeft: {
            cursor: "pointer",
            position: "absolute",
            float: "left",
            width: "20px",
            height: "20px",
            borderRadius: "24px",
            fontSize: "1.2rem",
            top: "30px",
            left: "5px",
        },
        DetailsToolTipFieldsLeft: {
            marginLeft: "20px"
        },
        DetailsToolTipFieldsRight: {
            marginLeft: "0px"
        },
        DetailsToolTipBodyContentExpandWithFields: {
            position: "relative",
            width: "300px",
            maxWidth: "530px",
            height: "auto",
            backgroundColor: "#e2e6f3",
            padding: "8px 11px",
            boxShadow: "0px 0px 3px rgba(32, 47, 47, 0.36)",
            borderRadius: "4px",
            fontWeight: 400,
            transform: "translate(0, 10px)",
        },
        DetailsToolTipBodyContentExpandWithoutFields: {
            position: "relative",
            width: "200px",
            maxWidth: "530px",
            height: "auto",
            backgroundColor: "#e2e6f3",
            padding: "8px 11px",
            boxShadow: "0px 0px 3px rgba(32, 47, 47, 0.36)",
            borderRadius: "4px",
            fontWeight: 400,
            transform: "translate(0, 10px)",
        },
        DetailsToolTipExpandRight: {
            position: "absolute",
            top: "-10px",
            left: "251px",
            height: "auto",
        },
        DetailsToolTipExpandLeft: {
            position: "absolute",
            top: "-10px",
            right: "250px",
            height: "auto",
        },
        DetailsToolTipDivOrderLoading: {
            position: "relative",
            backgroundColor: "#e2e6f3",
            padding: "8px 11px",
            boxShadow: "0px 0px 3px rgba(32, 47, 47, 0.36)",
            transform: "translate(0, 10px)",
            display: "flex", 
            flexDirection: "column", 
            width: "100px"
        },
        DetailsToolTipDivOrderExpandedFields: {
            display: "flex",
            flexDirection: "column",
            marginTop: "10px", 
            marginBottom: "10px",
        },
        DetailsToolTipDivOrderFields: {
            display: "flex", 
            flexDirection: "column", 
            // marginTop: "5px",
            marginBottom: "5px"
        },
        DetailsToolTipFieldsText: {
            fontFamily: "Inter",
            color: "#2b304f",
            fontWeight: 400,
            fontSize: "14px",
            marginTop: "2px",
            marginBottom: '4px'
        },
        DetailsToolTipFieldsValue: {
            fontFamily: "Inter",
            color: "#2b304f",
            fontWeight: 700,
            fontSize: "12px",
            marginTop: "1px",
            marginBottom: '5px'
        },
        DetailsToolTipExpandedFieldsValue: {
            fontFamily: "Inter",
            color: "#878BA1",
            fontStyle: "normal",
            fontWeight: "normal",
            lineHeight: "150%",
            marginBottom: "0px",
            fontSize: "12px",
        },
        DetailsToolTipExpandedFieldsText: {
            fontFamily: "Inter",
            color: "#2b304f",
            fontStyle: "normal",
            fontWeight: "normal",
            marginBottom: "10px",
            fontSize: "12px",
        },
        DetailsToolTipNoOpacity: {
            opacity: "1 !important",
        },
        DetailsToolTipSpanExtra: {
            fontFamily: "Inter",
            fontSize: "12px",
            color: "black"
        },
        DetailsToolTipCircular: {
            marginTop: "20px",
            marginLeft: "20px"
        }
    })
);